import { useEffect } from 'react';

import { getInstance } from 'src/utils/http-client/axios';

let tokens = {
    refreshToken: 'refreshToken',
    accessToken: 'accessToken'
};

//if multiple endpoint requested after access token expiry
//we should send only once and other wait until token refreshed
let refreshTokenRequested: any;

export const useInitAxios = () => {
    useEffect(() => {
        const httpClient = getInstance();

        httpClient.interceptors.request.use((req) => {
            return req;
        });
        //axios response interceptors
        httpClient.interceptors.response.use(
            (res) => res,
            async (error) => {
                if (!error || !error.response || !error.response.status) {
                    throw error;
                }
                const { refreshToken, accessToken } = tokens;

                if (accessToken) {
                    if (error.response.status === 401) {
                        // const { accessToken, refreshToken } = ;
                        /*
          if refresh token expired go to login page
          else if access token expired :
          1- save original request
          2- refresh token again
          3- request again
          */
                        if (refreshToken) {
                            //couldn't resolve token
                            //   history.replace("/login");
                        } else if (accessToken) {
                            const originalRequest = error.config;
                            originalRequest._retry = true;

                            try {
                                if (!refreshTokenRequested) {
                                    // console.log('refresh requested', refreshTokenRequested);
                                }
                                const isRefreshed = await refreshTokenRequested;
                                if (isRefreshed) {
                                    return httpClient(originalRequest);
                                }
                            } catch (err) {
                                //couldn't resolve token
                                //   history.replace("/login");
                            }
                        }
                    }
                }
                throw error;
            }
        );
    }, []);
    return {};
};
